import './DetailsMobileTools.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { useParams } from "react-router-dom";

import { fetchDetails } from "../../../slices/detailsSlice";
import { openDrawer } from "../../../slices/drawerSlice";

import Notes from "@mui/icons-material/Notes";

import DetailsJournal from "../DetailsJournal/DetailsJournal";

import { Status } from "../../../common-components/Status/Status";
import { TextButton } from "../../../common-components/Buttons/Buttons";

const DetailsMobileTools = ({title}) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const details = useSelector((state) => state.details.data);

    useEffect(() => {
        dispatch(fetchDetails({ departureId: id, token }))
    }, [dispatch, id, token]);

    const renderStatus = () => {
        switch (details?.attributes?.is_closed) {
            case false:
                return <Status title={"В процессе"} color={"danger"}/>
            case true:
                return <Status title={"Ликвидировано"} color={"success"}/>
            default:
                return <Status title={"Отсутствует"}/>
        }
    }

    const handleOpen = () => {
        dispatch(openDrawer({ content: <DetailsJournal departureId={id} token={token}/>, closeable: true }));
    }

    return (
        <div className={"details-mobile-tools"}>
            <div className={"details-mobile-tools_container"}>
                <div className={"details-mobile-tools_number"}>
                    {`${title}`}
                    {renderStatus()}
                </div>
                <div className={"details-mobile-tools_buttons"}>
                    <TextButton Icon={Notes} title={"Журнал"} active={true} onClick={handleOpen}/>
                </div>
            </div>
        </div>
    )
}

export default DetailsMobileTools;